// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hospitals.css */

.header-container {
  /* width: 100%; */
  
}

@media screen and (max-width:1069px) {
  
  .invoice-main{
    justify-content: inherit !important;
  }
}



@media screen and (max-width:1080px) {
  .header{
    /* display: flex !important;
    flex-direction: row !important; */
    overflow-x: scroll;

    padding-bottom: 10px !important;
  }

  
  .btn-effect{
    /* margin-top: 10px !important; */
    z-index: 0 !important;
  
  }

  .btn-mvr{
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }

  .filter{
    /* display: block !important; */
    padding: 10px;
    display:  flex !important;
    justify-content: end;
  }

  .select-dropdown{
   display: none;
  }

  .select-dropdown1{
    display: block !important;
    margin-left: 90px;
    margin-top: -10px;
  }
  
  
}



@media screen and (max-width:1164px) {
  .calculate-mvr-button button{
    height: -moz-fit-content !important;
    height: fit-content !important;
  }
}

.header {
  display: flex !important;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0px;
  background-color: #FFFFFF;
  flex: 1 1;
  width:calc(100vw-200px);
  border-radius: 5px;
}

.header-section {
  margin-right: 5px;
  position: relative;
 
  width:calc(100vw-200px)
}

.select-billing-category {
  position: relative;
  width: 200px;
}

.select-wrapper {
  position: relative;
  padding: 10px;
  border-radius: 20px;
  transition: all 0.3s ease;
  z-index: 1;
  
}

.select-wrapper:hover {
  /* Add a different border color on hover */
  border-color: #888;
  transform: scale(1.1);
}

.select-input {
  width: 150px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color:#F1F3F5;
  cursor: pointer;
  height: 10px;
  font-size: 12px;
  text-align: center;
}

.select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 180px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background-color: #F1F3F5;
  border-radius: 10px;
  text-align: center; 
  z-index: 1;
}



.select-dropdown ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.select-dropdown li {
  padding: 10px;
  cursor: pointer;
}

.select-dropdown li:hover {
  background-color: #f4f4f4;
}

.select-dropdown.show {
  display: block;
}

.select-dropdown1 {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 180px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background-color: #F1F3F5;
  border-radius: 10px;
  text-align: center; 
  z-index: 1;
}



.select-dropdown1 ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.select-dropdown1 li {
  padding: 10px;
  cursor: pointer;
}

.select-dropdown1 li:hover {
  background-color: #f4f4f4;
}

.select-dropdown1.show {
  display: block;
}

.send-invoice-button {
  display: flex;
  align-items: center;
}

.send-invoice-button button {
  padding: 5px 10px;
  border: none;
  border-radius: 20px;
  background-color: #007bff;
  color: white;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.send-invoice-button button:hover {
  transform: scale(1.1);
}

.send-invoice-button button.scale-effect {
  transform: scale(1.1);
}

/* Search Hospital */
/* Hospitals.css */

/* ... (Previous CSS code) */

/* Hospitals.css */

/* ... (Previous CSS code) */

.search-hospitals {
  display: inline-flex;
  align-items: center;
  padding: 2px 5px;
  border: 1px solid #dfe1e5;
  border-radius: 24px;
  transition: border-color 0.3s, box-shadow 0.3s;
  color: #007bff;
  background-color: #F1F3F5;
  margin-left: 0px;
  min-width: 200px;
}

.search-hospitals:hover {
  border-color: #a0a4a8;
  transform: scale(1.05);
}

.search-hospitals:focus-within {
  border-color: #4285f4;
  box-shadow: 0 0 0 3px #f1f3f4;
}

.search-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 8px;
  margin-top: 5px;
  margin-left: 3px;
}



.search-bar {
  display: inline-block;
  padding: 2px 8px;
  border: none;
  outline: none;
  font-size: 13px;
  width: 200px;
  background-color: transparent;
  height: 10px;
}

/* Optional: Add transitions for the search icon */
.search-hospitals:hover .search-icon {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}

.search-hospitals:focus-within .search-icon {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}

.filter{
  display: none;
  background-color: #FFFFFF;
  
}

.filter>div{
  background-color: #0056b3;
  padding: 7px;
  color: #FFFFFF;
  border-radius: 5px;
  font-size: 14px;
  display: flex;
  cursor: pointer;
}

/* Hospitals.css */

.date-range-picker {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease;
  margin-right: 5px;
  margin-left: 10px;
  position: inherit;
  z-index: 1;

  
}

.date-range-selected {
  display: flex;
  margin-left: 10px;
}

.date-field {
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: fit-content; */
  /* padding: 5px 5%; */
  padding : 5px;
  width: -moz-fit-content;
  width: fit-content;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 12px;
}

.date-field:hover {
  background-color: #e8e8e8;
}

.date-field.active {
  border-color: #50c878;
}

.date-range-container {
  position: absolute;
  top: 10px;
  left: 0;
  background-color: #fff;
  border: none;
  /* border: 1px solid #ccc; */
  padding: 10px;
  z-index: 1;
  box-shadow: 0px 0px 5px grey;
}

.clear-selection-button {
  display: display-inside;
  padding: 5px 5px;
  border: none;
  border-radius: 15px;
  background-color: #f9ca48; /* Slight yellow background */
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  /* font-size: 15px; */
  width:140px;
  font-size: 13px;
  height: 30px;
}

.clear-selection-button:hover {
  background-color: #e4b81d; /* Darker yellow on hover */
}

.date-range-picker:hover {
  transform: scale(1.004); /* Increase the size on hover */
}

.date-range-picker.active {
  transform: scale(1.1); 
}

.select-button {
  background-color: #50c878; /* Green background color */
  color: white;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
  margin-left: 40px;
  margin-top: 10px;
  font-size: 13px;
}

.select-button:hover {
  background-color: #44d781a1; /* Hover effect color */
}

.download-excel-button {
  margin-left: 5px; /* Add the desired left margin */
  padding: 10px 10px; /* Adjust the padding to increase the size */
  font-size: 28px;
}

.btn-effect{
  font-size: 10px !important;
 }

 .btn-effect:hover{
  transform: scale(1.05);
 }

 .btn-mvr{
  height: 25px !important;
 }

 

/* .download-excel-button button {
  /* Your button styles... */


/* ClearAllIcon.css */

/* Hospitals.css */

.clear-all-icon-container {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 50px; 
  size: 50px;
}

.clear-all-icon-container:hover {
  transform: scale(1.3);
}

.clear-all-icon {
  font-size: 50px; /* Set the initial size of the icon to 25px */
  size: 50px;
}

/* Add styles for the text (optional) */
.clear-all-icon-container span {
  margin-right: 10px;
  font-size: 50px; 
  size: 50px;
}

.button-effect:hover {
  transform: scale(1.2); /* Adjust the scale factor as per your preference */
  transition: transform 0.2s ease; /* Adjust the transition duration for the desired effect */
}

.date-range-wrapper {
  position: absolute;
  top: 100%;

}

.css-i4bv87-MuiSvgIcon-root{
  width: 27px !important;
}

.calculate-mvr-button {
  display: inline-block;
  margin-right: 10px;
  width: -moz-fit-content;
  width: fit-content;
  /* You can add more styles here as needed */
}

.calculate-mvr-button button {
  display: flex;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
  /* Add any other button-specific styles here */
}

.calculate-mvr-button button .MuiSvgIcon-root {
  /* Add specific styles for the CalculateIcon, if needed */
  margin-right: 5px; /* Adjust the spacing between the icon and the button text */
}

.container-main{
 padding-top: 10px;
 height: 100%;
 /* width: 100vw; */
 padding-right: 10px;
  background-color: #F4F9FF;
}




/* Add styles for the modal */
.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
  width: 600px;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  z-index: 9999; /* Make sure the modal appears on top of other elements */
}

/* Add styles for the modal overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black overlay */
  z-index: 9998; /* Make sure the overlay appears below the modal but above other elements */
}

/* Add this CSS to your existing CSS file or create a new CSS file and import it */

/* Table Container Styles */
.table-container {
  max-height: 300px; /* Set the maximum height for the table container */
  overflow-y: auto; /* Enable vertical scrolling for the table container */
}

/* Search Input Styles */
.search-input {
  margin-top: 10px; /* Add some spacing between the search input and the table */
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

/* Freeze Table Header Styles */
.modal-table {
  width: 100%;
}

.modal-table thead {
  position: sticky;
  top: 0;
  background-color: #f5f5f5;
}

/* Optional: Add some padding to the header cells */
.modal-table th {
  padding: 8px;
}

/* Optional: Add some styles for the table rows */
.modal-table tbody tr {
  border-bottom: 1px solid #ccc;
}

/* Optional: Add some padding to the table cells */
.modal-table td {
  padding: 8px;
}

/* Optional: Add some styles for the footer buttons */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.modal-send-button {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;
}

.modal-send-button:hover {
  background-color: #0056b3;
}


.rdrMonth{

  width: 250px;
}

.rdrDateDisplayWrapper{
  width: 270px;
}

.rdrMonthAndYearPickers{
  width: -moz-fit-content;
  width: fit-content;
}

.rdrDefinedRangesWrapper{
  width: 200px;
}
.rdrMonthAndYearPickersr> select{
  width: 60px;
}

/* .date-range-container{
  position: sticky;
} */


.filtericon{
  width: 17px !important;
  margin-top: -5px;
} 


.select-btn1{
  font-size: 11px !important;
  width: -moz-fit-content !important;
  width: fit-content !important;
  margin-top: 10px !important;
  /* text-align: center; */
  margin-left: 40px !important;
  
}

.clear-btn1{
  font-size: 11px !important;
  width: max-content !important; 
}`, "",{"version":3,"sources":["webpack://./src/components/Hospital/Hospitals.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,iBAAiB;;AAEnB;;AAEA;;EAEE;IACE,mCAAmC;EACrC;AACF;;;;AAIA;EACE;IACE;qCACiC;IACjC,kBAAkB;;IAElB,+BAA+B;EACjC;;;EAGA;IACE,iCAAiC;IACjC,qBAAqB;;EAEvB;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;IAC/B,aAAa;IACb,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;GACC,aAAa;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;EACnB;;;AAGF;;;;AAIA;EACE;IACE,mCAA8B;IAA9B,8BAA8B;EAChC;AACF;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,SAAO;EACP,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;;EAElB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;;AAEZ;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;;;AAIA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;;;AAIA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB,kBAAkB;;AAElB,4BAA4B;;AAE5B,kBAAkB;;AAElB,4BAA4B;;AAE5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;;;AAIA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yBAAyB;;AAE3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;;;AAGZ;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,uBAAkB;EAAlB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB,EAAE,6BAA6B;EACxD,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;AAC1D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B,EAAE,uBAAuB;AACtD;;AAEA;EACE,gBAAgB,EAAE,gCAAgC;EAClD,kBAAkB,EAAE,4CAA4C;EAChE,eAAe;AACjB;;AAEA;EACE,0BAA0B;CAC3B;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,uBAAuB;CACxB;;;;AAID;4BAC4B;;;AAG5B,qBAAqB;;AAErB,kBAAkB;;AAElB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe,EAAE,6CAA6C;EAC9D,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB,EAAE,mDAAmD;EAC1E,+BAA+B,EAAE,0DAA0D;AAC7F;;AAEA;EACE,kBAAkB;EAClB,SAAS;;AAEX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,yDAAyD;EACzD,iBAAiB,EAAE,4DAA4D;AACjF;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;EAClB,yBAAyB;AAC3B;;;;;AAKA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa,EAAE,yDAAyD;AAC1E;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,mCAAmC;EACzE,aAAa,EAAE,2EAA2E;AAC5F;;AAEA,kFAAkF;;AAElF,2BAA2B;AAC3B;EACE,iBAAiB,EAAE,mDAAmD;EACtE,gBAAgB,EAAE,sDAAsD;AAC1E;;AAEA,wBAAwB;AACxB;EACE,gBAAgB,EAAE,4DAA4D;EAC9E,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,6BAA6B;AAC/B;;AAEA,kDAAkD;AAClD;EACE,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA;;GAEG;;;AAGH;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;EACE,0BAA0B;EAC1B,kCAA6B;EAA7B,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;;AAE9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B","sourcesContent":["/* Hospitals.css */\n\n.header-container {\n  /* width: 100%; */\n  \n}\n\n@media screen and (max-width:1069px) {\n  \n  .invoice-main{\n    justify-content: inherit !important;\n  }\n}\n\n\n\n@media screen and (max-width:1080px) {\n  .header{\n    /* display: flex !important;\n    flex-direction: row !important; */\n    overflow-x: scroll;\n\n    padding-bottom: 10px !important;\n  }\n\n  \n  .btn-effect{\n    /* margin-top: 10px !important; */\n    z-index: 0 !important;\n  \n  }\n\n  .btn-mvr{\n    margin-top: 10px !important;\n    margin-bottom: 10px !important;\n  }\n\n  .filter{\n    /* display: block !important; */\n    padding: 10px;\n    display:  flex !important;\n    justify-content: end;\n  }\n\n  .select-dropdown{\n   display: none;\n  }\n\n  .select-dropdown1{\n    display: block !important;\n    margin-left: 90px;\n    margin-top: -10px;\n  }\n  \n  \n}\n\n\n\n@media screen and (max-width:1164px) {\n  .calculate-mvr-button button{\n    height: fit-content !important;\n  }\n}\n\n.header {\n  display: flex !important;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 0px;\n  background-color: #FFFFFF;\n  flex: 1;\n  width:calc(100vw-200px);\n  border-radius: 5px;\n}\n\n.header-section {\n  margin-right: 5px;\n  position: relative;\n \n  width:calc(100vw-200px)\n}\n\n.select-billing-category {\n  position: relative;\n  width: 200px;\n}\n\n.select-wrapper {\n  position: relative;\n  padding: 10px;\n  border-radius: 20px;\n  transition: all 0.3s ease;\n  z-index: 1;\n  \n}\n\n.select-wrapper:hover {\n  /* Add a different border color on hover */\n  border-color: #888;\n  transform: scale(1.1);\n}\n\n.select-input {\n  width: 150px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background-color:#F1F3F5;\n  cursor: pointer;\n  height: 10px;\n  font-size: 12px;\n  text-align: center;\n}\n\n.select-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 180px;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  background-color: #F1F3F5;\n  border-radius: 10px;\n  text-align: center; \n  z-index: 1;\n}\n\n\n\n.select-dropdown ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.select-dropdown li {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.select-dropdown li:hover {\n  background-color: #f4f4f4;\n}\n\n.select-dropdown.show {\n  display: block;\n}\n\n.select-dropdown1 {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 180px;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  background-color: #F1F3F5;\n  border-radius: 10px;\n  text-align: center; \n  z-index: 1;\n}\n\n\n\n.select-dropdown1 ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.select-dropdown1 li {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.select-dropdown1 li:hover {\n  background-color: #f4f4f4;\n}\n\n.select-dropdown1.show {\n  display: block;\n}\n\n.send-invoice-button {\n  display: flex;\n  align-items: center;\n}\n\n.send-invoice-button button {\n  padding: 5px 10px;\n  border: none;\n  border-radius: 20px;\n  background-color: #007bff;\n  color: white;\n  font-size: 14px;\n  outline: none;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.send-invoice-button button:hover {\n  transform: scale(1.1);\n}\n\n.send-invoice-button button.scale-effect {\n  transform: scale(1.1);\n}\n\n/* Search Hospital */\n/* Hospitals.css */\n\n/* ... (Previous CSS code) */\n\n/* Hospitals.css */\n\n/* ... (Previous CSS code) */\n\n.search-hospitals {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 5px;\n  border: 1px solid #dfe1e5;\n  border-radius: 24px;\n  transition: border-color 0.3s, box-shadow 0.3s;\n  color: #007bff;\n  background-color: #F1F3F5;\n  margin-left: 0px;\n  min-width: 200px;\n}\n\n.search-hospitals:hover {\n  border-color: #a0a4a8;\n  transform: scale(1.05);\n}\n\n.search-hospitals:focus-within {\n  border-color: #4285f4;\n  box-shadow: 0 0 0 3px #f1f3f4;\n}\n\n.search-icon {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  margin-right: 8px;\n  margin-top: 5px;\n  margin-left: 3px;\n}\n\n\n\n.search-bar {\n  display: inline-block;\n  padding: 2px 8px;\n  border: none;\n  outline: none;\n  font-size: 13px;\n  width: 200px;\n  background-color: transparent;\n  height: 10px;\n}\n\n/* Optional: Add transitions for the search icon */\n.search-hospitals:hover .search-icon {\n  transform: scale(1.1);\n  transition: transform 0.3s ease;\n}\n\n.search-hospitals:focus-within .search-icon {\n  transform: scale(1.1);\n  transition: transform 0.3s ease;\n}\n\n.filter{\n  display: none;\n  background-color: #FFFFFF;\n  \n}\n\n.filter>div{\n  background-color: #0056b3;\n  padding: 7px;\n  color: #FFFFFF;\n  border-radius: 5px;\n  font-size: 14px;\n  display: flex;\n  cursor: pointer;\n}\n\n/* Hospitals.css */\n\n.date-range-picker {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  margin-right: 5px;\n  margin-left: 10px;\n  position: inherit;\n  z-index: 1;\n\n  \n}\n\n.date-range-selected {\n  display: flex;\n  margin-left: 10px;\n}\n\n.date-field {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* height: fit-content; */\n  /* padding: 5px 5%; */\n  padding : 5px;\n  width: fit-content;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 15px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  font-size: 12px;\n}\n\n.date-field:hover {\n  background-color: #e8e8e8;\n}\n\n.date-field.active {\n  border-color: #50c878;\n}\n\n.date-range-container {\n  position: absolute;\n  top: 10px;\n  left: 0;\n  background-color: #fff;\n  border: none;\n  /* border: 1px solid #ccc; */\n  padding: 10px;\n  z-index: 1;\n  box-shadow: 0px 0px 5px grey;\n}\n\n.clear-selection-button {\n  display: display-inside;\n  padding: 5px 5px;\n  border: none;\n  border-radius: 15px;\n  background-color: #f9ca48; /* Slight yellow background */\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  /* font-size: 15px; */\n  width:140px;\n  font-size: 13px;\n  height: 30px;\n}\n\n.clear-selection-button:hover {\n  background-color: #e4b81d; /* Darker yellow on hover */\n}\n\n.date-range-picker:hover {\n  transform: scale(1.004); /* Increase the size on hover */\n}\n\n.date-range-picker.active {\n  transform: scale(1.1); \n}\n\n.select-button {\n  background-color: #50c878; /* Green background color */\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 5px 10px;\n  cursor: pointer;\n  margin-left: 40px;\n  margin-top: 10px;\n  font-size: 13px;\n}\n\n.select-button:hover {\n  background-color: #44d781a1; /* Hover effect color */\n}\n\n.download-excel-button {\n  margin-left: 5px; /* Add the desired left margin */\n  padding: 10px 10px; /* Adjust the padding to increase the size */\n  font-size: 28px;\n}\n\n.btn-effect{\n  font-size: 10px !important;\n }\n\n .btn-effect:hover{\n  transform: scale(1.05);\n }\n\n .btn-mvr{\n  height: 25px !important;\n }\n\n \n\n/* .download-excel-button button {\n  /* Your button styles... */\n\n\n/* ClearAllIcon.css */\n\n/* Hospitals.css */\n\n.clear-all-icon-container {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 50px; \n  size: 50px;\n}\n\n.clear-all-icon-container:hover {\n  transform: scale(1.3);\n}\n\n.clear-all-icon {\n  font-size: 50px; /* Set the initial size of the icon to 25px */\n  size: 50px;\n}\n\n/* Add styles for the text (optional) */\n.clear-all-icon-container span {\n  margin-right: 10px;\n  font-size: 50px; \n  size: 50px;\n}\n\n.button-effect:hover {\n  transform: scale(1.2); /* Adjust the scale factor as per your preference */\n  transition: transform 0.2s ease; /* Adjust the transition duration for the desired effect */\n}\n\n.date-range-wrapper {\n  position: absolute;\n  top: 100%;\n\n}\n\n.css-i4bv87-MuiSvgIcon-root{\n  width: 27px !important;\n}\n\n.calculate-mvr-button {\n  display: inline-block;\n  margin-right: 10px;\n  width: fit-content;\n  /* You can add more styles here as needed */\n}\n\n.calculate-mvr-button button {\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  /* Add any other button-specific styles here */\n}\n\n.calculate-mvr-button button .MuiSvgIcon-root {\n  /* Add specific styles for the CalculateIcon, if needed */\n  margin-right: 5px; /* Adjust the spacing between the icon and the button text */\n}\n\n.container-main{\n padding-top: 10px;\n height: 100%;\n /* width: 100vw; */\n padding-right: 10px;\n  background-color: #F4F9FF;\n}\n\n\n\n\n/* Add styles for the modal */\n.modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 90%;\n  width: 600px;\n  background-color: white;\n  border-radius: 10px;\n  padding: 20px;\n  z-index: 9999; /* Make sure the modal appears on top of other elements */\n}\n\n/* Add styles for the modal overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black overlay */\n  z-index: 9998; /* Make sure the overlay appears below the modal but above other elements */\n}\n\n/* Add this CSS to your existing CSS file or create a new CSS file and import it */\n\n/* Table Container Styles */\n.table-container {\n  max-height: 300px; /* Set the maximum height for the table container */\n  overflow-y: auto; /* Enable vertical scrolling for the table container */\n}\n\n/* Search Input Styles */\n.search-input {\n  margin-top: 10px; /* Add some spacing between the search input and the table */\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 100%;\n  font-size: 14px;\n}\n\n/* Freeze Table Header Styles */\n.modal-table {\n  width: 100%;\n}\n\n.modal-table thead {\n  position: sticky;\n  top: 0;\n  background-color: #f5f5f5;\n}\n\n/* Optional: Add some padding to the header cells */\n.modal-table th {\n  padding: 8px;\n}\n\n/* Optional: Add some styles for the table rows */\n.modal-table tbody tr {\n  border-bottom: 1px solid #ccc;\n}\n\n/* Optional: Add some padding to the table cells */\n.modal-table td {\n  padding: 8px;\n}\n\n/* Optional: Add some styles for the footer buttons */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.modal-send-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 5px;\n  background-color: #007bff;\n  color: white;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none;\n  transition: background-color 0.3s ease;\n}\n\n.modal-send-button:hover {\n  background-color: #0056b3;\n}\n\n\n.rdrMonth{\n\n  width: 250px;\n}\n\n.rdrDateDisplayWrapper{\n  width: 270px;\n}\n\n.rdrMonthAndYearPickers{\n  width: fit-content;\n}\n\n.rdrDefinedRangesWrapper{\n  width: 200px;\n}\n.rdrMonthAndYearPickersr> select{\n  width: 60px;\n}\n\n/* .date-range-container{\n  position: sticky;\n} */\n\n\n.filtericon{\n  width: 17px !important;\n  margin-top: -5px;\n} \n\n\n.select-btn1{\n  font-size: 11px !important;\n  width: fit-content !important;\n  margin-top: 10px !important;\n  /* text-align: center; */\n  margin-left: 40px !important;\n  \n}\n\n.clear-btn1{\n  font-size: 11px !important;\n  width: max-content !important; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
